import { InputHTMLAttributes, forwardRef } from 'react';
import clsx from 'clsx';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  iconLeft?: React.ReactNode;
  iconRight?: React.ReactNode;
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, Props>(
  ({ className, iconLeft, iconRight, invalid, ...rest }, ref) => {
    if (iconLeft || iconRight) {
      return (
        <div className="relative">
          {iconLeft && (
            <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-text-muted pointer-events-none">
              {iconLeft}
            </span>
          )}
          <input
            ref={ref}
            className={clsx(
              'h-10 w-full rounded-lg border bg-surface text-sm text-text-primary placeholder:text-text-muted',
              'transition-colors duration-150',
              'hover:border-border-strong',
              'focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary-soft',
              'disabled:opacity-60 disabled:cursor-not-allowed',
              invalid ? 'border-danger focus:border-danger focus:ring-danger-soft' : 'border-border',
              iconLeft ? 'pl-10' : 'pl-3.5',
              iconRight ? 'pr-10' : 'pr-3.5',
              className,
            )}
            {...rest}
          />
          {iconRight && (
            <span className="absolute inset-y-0 right-0 flex items-center pr-3 text-text-muted">
              {iconRight}
            </span>
          )}
        </div>
      );
    }
    return (
      <input
        ref={ref}
        className={clsx(
          'h-10 w-full rounded-lg border bg-surface px-3.5 text-sm text-text-primary placeholder:text-text-muted',
          'transition-colors duration-150',
          'hover:border-border-strong',
          'focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary-soft',
          'disabled:opacity-60 disabled:cursor-not-allowed',
          invalid ? 'border-danger focus:border-danger focus:ring-danger-soft' : 'border-border',
          className,
        )}
        {...rest}
      />
    );
  },
);
Input.displayName = 'Input';
